import { AnalyticsEvent } from '../analytics-event';

export type PageViewedName =
  | 'home'
  | 'bookshelf'
  | 'lists'
  | 'holds'
  | 'purchase_suggestions'
  | 'history'
  | 'statistics'
  | 'challenges'
  | 'events'
  | 'rankings'
  | 'notifications'
  | 'OLE'
  | 'career_plan'
  | 'onboarding'
  | 'account'
  | 'search_results'
  | 'TDP'
  | 'LDP';

export type PageViewedOrigin = 'external_link' | 'banner' | 'user_navigation';

type PageViewedEventProps = {
  page_name: PageViewedName;
  previous_section?: PageViewedName;
  view_origin: PageViewedOrigin;
  record_id?: string;
  list_id?: string;
};

export class PageViewedEvent implements AnalyticsEvent<PageViewedEventProps> {
  readonly name = 'page_viewed';
  readonly props: PageViewedEventProps;

  constructor(props: PageViewedEventProps) {
    this.props = props;
  }
}
